/**
 * WorkDocLineSpacing — Line spacing and paragraph spacing controls.
 */
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { WrapText } from "lucide-react";

const LINE_SPACINGS = [1.0, 1.15, 1.5, 2.0, 2.5, 3.0];

export default function WorkDocLineSpacing({ editor }) {
  if (!editor) return null;

  const setLineHeight = (value) => {
    editor.chain().focus().setLineHeight?.(value).run();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 px-2 text-xs gap-1 border border-gray-700 hover:bg-gray-800 text-gray-400">
          <WrapText className="w-4 h-4" />
          <span className="hidden sm:inline">Spacing</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-2 bg-gray-900 border-gray-700" side="bottom" align="start">
        <p className="text-[10px] uppercase tracking-wider text-gray-500 mb-1.5 px-1">Line Spacing</p>
        <div className="grid grid-cols-3 gap-1">
          {LINE_SPACINGS.map((s) => (
            <button
              key={s}
              className="px-2 py-2 text-sm text-gray-300 hover:bg-gray-800 rounded text-center"
              onClick={() => setLineHeight(s)}
            >
              <div className="text-xs font-medium">{s}x</div>
              <div className="flex flex-col items-center gap-0.5 mt-1">
                <div className="w-6 h-0.5 bg-gray-500 rounded" style={{ margin: `${Math.max(0, (s - 1) * 2)}px 0` }} />
                <div className="w-6 h-0.5 bg-gray-500 rounded" style={{ margin: `${Math.max(0, (s - 1) * 2)}px 0` }} />
              </div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
